class ComponentModal extends HTMLElement {
  constructor() {
    super()
    this.content = this.querySelector('.component-dialog__content')
    this.overlay = this.querySelector('.component-dialog__overlay')

    this.closeButton = this.querySelector('.component-dialog__close')
    if (this.closeButton) {
      this.closeButton.addEventListener('click', this.close.bind(this))
    }

    this.isOpen = true
  }

  open() {
    this.setAttribute('data-state', 'open')
    this.content.setAttribute('data-state', 'open')
    this.overlay.setAttribute('data-state', 'open')
    this.isOpen = true

    // Disable scroll when the modal is open
    document.body.classList.add('component-dialog-open')
  }

  close() {
    this.setAttribute('data-state', 'closing')
    this.content.setAttribute('data-state', 'closing')
    this.overlay.setAttribute('data-state', 'closing')

    // Re-enable scroll when the modal is closed
    document.body.classList.remove('component-dialog-open')

    this.content.addEventListener(
      'animationend',
      () => {
        this.setAttribute('data-state', 'closed')
        this.content.setAttribute('data-state', 'closed')
        this.overlay.setAttribute('data-state', 'closed')
        this.isOpen = false
      },
      { once: true }
    )
  }

  connectedCallback() {
    // Handle keyboard events
    document.addEventListener('keydown', this.handleKeyDown.bind(this))

    // Add a click event listener to the overlay
    this.overlay.addEventListener('click', this.handleOverlayClick.bind(this))
  }

  disconnectedCallback() {
    // Remove event listener when the modal is removed from the DOM
    document.removeEventListener('keydown', this.handleKeyDown.bind(this))
    this.overlay.removeEventListener('click', this.handleOverlayClick.bind(this))
  }

  handleKeyDown(event) {
    if (this.isOpen && event.key === 'Escape') {
      this.close()
    }
  }

  handleOverlayClick(event) {
    if (event.target === this.overlay) {
      this.close()
    }
  }
}

customElements.define('component-modal', ComponentModal)
